import { Action, OperationType, Position } from '../../index';
import {
  ASYNC_UPLOAD_DISPATCHER_NAME
} from '../../dispatcher/config/Constants';
import { WarningType, WindowType } from '../../dispatcher/Types';
import ProgressBarHolder from '../../dispatcher/modules/progressbar/ProgressBarHolder';

export const updateProgresses: Action = [{
  independent: true,
  args: ['progresses'],
  moduleName: 'ProgressBar',
  name: 'updateProgress',
  executeType: 'visible'
}, {
  condition: '{isUploadWidgetUp}',
  conditionOperations: [{
    args: ['progresses'],
    moduleName: 'ProgressBarHolder',
    name: 'updateProgress'
  }, {
    independent: true,
    data: {
      template: {
        moduleId: 'UploadProgressWidget',
        placeholders: {
          bind: {
            numberOfItems: 'Object.keys({progresses}).length'
          }
        },
        bind: {
          title: 'Object.keys({progresses}).length === 0 ? "UploadProgress.titleAllUploaded" : "UploadProgress.title"'
        }
      }
    },
    args: ['title', 'placeholders'],
    name: 'updateTitle',
    moduleName: 'Widget'
  }],
  type: OperationType.conditional
}];

/**
 * Action called on DispatcherUploadProgress action and this action will hold all operations from
 * OperationType.upload progressOperations.
 */
export const DispatcherUploadGroupActions: Action = [];

export const DispatcherUploadProgress: Action = [{
  items: ['progresses'],
  referenceDispatcherId: ASYNC_UPLOAD_DISPATCHER_NAME,
  type: OperationType.syncDispatchersDataItem
}, {
  name: 'DispatcherUploadGroupActions',
  type: OperationType.action
}, {
  actionType: {
    pos: Position.start,
    dispatcherId: ASYNC_UPLOAD_DISPATCHER_NAME
  },
  name: 'updateProgresses',
  type: OperationType.action
}];

export const CancelAllDispatcherUploadsInProgress: Action = [{
  data: {
    cancelRequestForFile: 'ALL',
    cancelRequestForUploadGroup: 'ALL'
  },
  name: 'DispatcherUploadProgressCancel',
  type: OperationType.action
}];

export const DispatcherUploadProgressCancel: Action = [{
  data: {
    template: {
      bind: {
        cancelRequestForFile: '{cancelRequestForFile}',
        cancelRequestForUploadGroup: '{cancelRequestForUploadGroup}'
      }
    }
  },
  type: OperationType.cancelRequest
}, {
  items: ['progresses'],
  referenceDispatcherId: ASYNC_UPLOAD_DISPATCHER_NAME,
  type: OperationType.syncDispatchersDataItem
}, {
  condition: '{progresses} && Object.values({progresses}).every(percentage=>percentage!==100)',
  conditionOperations: [{
    data: {
      isUploadWidgetUp: false
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  persistent: ['progresses'],
  type: OperationType.removePersistentData
}];

export const ShowUploadFileProgresses: Action = [{
  condition: '{progresses}',
  conditionOperations: [{
    condition: '!{isUploadWidgetUp}',
    conditionOperations: [{
      data: {
        template: {
          bind: {
            numberOfItems: 'Object.keys({progresses}).length'
          }
        }
      },
      type: OperationType.data
    }, {
      children: [{
        propArgs: ['progresses'],
        render: ProgressBarHolder
      }],
      className: 'md widget',
      items: [{
        operations: [{
          name: 'closeWidget_UploadProgressWidget',
          type: OperationType.action
        }, {
          name: 'CancelAllDispatcherUploadsInProgress',
          type: OperationType.action
        }],
        btnName: 'UploadProgress.cancel',
        btnConfig: {
          pos: Position.end,
          fillMode: 'flat'
        }
      }],
      placeholders: {
        template: {
          bind: {
            numberOfItems: '{numberOfItems}'
          }
        }
      },
      title: 'UploadProgress.title',
      width: 600,
      height: 300,
      resizable: false,
      name: 'UploadProgressWidget',
      type: OperationType.widget
    }, {
      data: {
        isUploadWidgetUp: true
      },
      type: OperationType.data
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const uploadFailedWarning: Action = [{
  className: 'sm',
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'failedUpload.ok',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }],
  text: 'failedUpload.text',
  title: 'failedUpload.title',
  type: OperationType.warning,
  warningType: WarningType.error
}];

export const uploadFileMissing: Action = [{
  className: 'sm',
  items: [{
    operations: [{
      name: 'clearUploadPanel',
      type: OperationType.action
    }],
    btnName: 'uploadFileMissing.ok',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }],
  text: 'uploadFileMissing.text',
  title: 'uploadFileMissing.title',
  type: OperationType.warning,
  warningType: WarningType.info
}];
